module.exports = __webpack_public_path__ + "static/media/necklace.0115e832.jpg";